import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	renderingFailed: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.rendering-failed',
		defaultMessage: 'Internal error. {linkStart}Resend the invite{linkEnd} later.',
		description: 'description of this type of error',
	},
	requestTooLong: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.request-too-long',
		defaultMessage:
			'Notification size is greater than 6 MB. Reduce the size of customer invite template.',
		description: 'description of this type of error',
	},
	emailValidationFailure: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.email-validation-failure',
		defaultMessage:
			'Unable to validate customer’s email address. Check the format and invite again.',
		description: 'description of this type of error',
	},
	rfc1918LanIpRoutingFailure: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.rfc-1918-lan-ip-routing-failure',
		defaultMessage:
			'Customer’s email address belongs to a private address space. Invite again using the correct email address.',
		description: 'description of this type of error',
	},
	suppressedMessageWhenUnsuppressionIsEnabled: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.suppressed-message-when-unsuppression-is-enabled',
		defaultMessage:
			'Customer’s email address is on a suppression list. Resend invite from the {linkStart}Customers page{linkEnd}.',
		description: 'description of this type of error when un-suppression feature is enabled',
	},
	suppressedMessageWhenUnsuppressionIsDisabled: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.suppressed-message-when-unsuppression-is-disabled',
		defaultMessage: 'Customer email added to the suppression list.',
		description: 'description of this type of error when un-suppression feature is disabled',
	},
	bounced: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.bounced',
		defaultMessage: 'Error from email provider',
		description: 'description of this type of error',
	},
	emailNotificationLimitReached: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.email-notification-limit-reached',
		defaultMessage: 'Reached the email notifications limit for {siteUrl}.',
		description: 'description of this type of error',
	},
	defaultValue: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.default-value',
		defaultMessage: 'Unspecified error. Try again later.',
		description: 'description of this type of error',
	},
	tableHeaderDateTime: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.table-header-date-time',
		defaultMessage: 'Date and time',
		description: 'title of the table header',
	},
	tableHeaderNotificationName: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.table-header-notification-name',
		defaultMessage: 'Notification name',
		description: 'title of the table header',
	},
	tableHeaderCustomerEmail: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.table-header-customer-email',
		defaultMessage: 'Customer name',
		description: 'title of the table header',
	},
	tableHeaderErrorMessage: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.table-header-error-message',
		defaultMessage: 'What went wrong',
		description: 'title of the table header',
	},
	notificationTypeInfo: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.notification-type-info',
		defaultMessage: 'Includes customer invites only',
		description: 'tooltip content for notificationType table column',
	},
	customerInvited: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.customer-invited',
		defaultMessage: 'Customer invited',
		description: 'a type of customer notification name',
	},
	loadMoreLogs: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.load-more-logs',
		defaultMessage: 'Loading more logs...',
		description: 'text to show more rows to be fetched',
	},
});
